import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum AppTableInteractionEventOption {
  AddConnection = "add_connection",
  ViewConnections = "view_connections",
  ViewZaps = "view_zaps",
  ViewApp = "view_app",
}

export function useEmitAppTableInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: AppTableInteractionEventOption) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.AppTable,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
